/**
 * Remembers the last chat route (including ``/chat/:id``) so the Settings/Help
 * back arrows return to that exact conversation. ``sessionStorage``-scoped: it
 * only needs to survive the in-tab Settings/Help round-trip and dies on tab
 * close like the rest of the session-scoped guest state.
 */
const KEY = 'votemate_last_chat_path';

export const rememberChatPath = (path: string): void => {
  try {
    sessionStorage.setItem(KEY, path);
  } catch {
    // sessionStorage disabled (private mode / quota) — best-effort.
  }
};

export const getRememberedChatPath = (): string | null => {
  try {
    return sessionStorage.getItem(KEY);
  } catch {
    return null;
  }
};
